<template>
  <div class="vh-customer-componets-editor-preview">
    <component
      :is="componetPreview"
      :units.sync="currentInfo.components"
      :menuInfo="currentInfo"
      :uuid="currentInfo.uuid"
      :pre="pre"
    ></component>
  </div>
</template>
<script>
  import { TypeMaps } from '../componentMap';
  // 预览组件区域
  import componentCustomer from './component-customer';
  import ComponentDes from './component-des';
  import componentDownload from './component-download';
  import componentMoments from './component-moments';
  import componentSummary from './component-summary';
  import componentPlayback from './component-playback';
  import componentAi from './component-ai';

  export default {
    props: {
      currentInfo: {
        required: true
      },
      pre: {
        required: true
      }
    },

    components: {
      'component-customer': componentCustomer,
      'component-des': ComponentDes,
      'component-download': componentDownload,
      'component-ai': componentAi,
      'component-moments': componentMoments,
      'component-summary': componentSummary,
      'component-playback': componentPlayback
    },

    computed: {
      type: function () {
        return this.currentInfo.type;
      },

      componetPreview: function () {
        return TypeMaps[this.type];
      }
    },

    created() {
      // EventBus.$on(eventsType.INIT_MENU_INFO, this.initInfo)
    },

    methods: {
      initInfo(menuInfo) {
        this.currentInfo = menuInfo;
        if (this.type == 1) {
          this.currentInfo.components = this.currentInfo.components.map(item => {
            return {
              ...item
            };
          });
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .vh-customer-componets-editor-preview {
    height: 100%;
  }
</style>
